export const OPTIONS_YES_NO = [
  { value: 1, label: "SI" },
  { value: 0, label: "NO" },
];

export const OPTIONS_ACTIVE_INACTIVE = [
  { value: 1, label: "Activo" },
  { value: 0, label: "Inactivo" },
];
